var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 450",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m440.04 413.42h-430.08c-2.76 0-5-2.24-5-5v-366.84c0-2.76 2.24-5 5-5h430.08c2.76 0 5 2.24 5 5v366.85c0 2.75-2.24 4.99-5 4.99zm-425.08-10h420.08v-356.84h-420.08z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 321.43c-53.17 0-96.43-43.26-96.43-96.43s43.26-96.43 96.43-96.43 96.43 43.26 96.43 96.43-43.26 96.43-96.43 96.43zm0-182.86c-47.65 0-86.43 38.77-86.43 86.43s38.77 86.43 86.43 86.43 86.43-38.77 86.43-86.43-38.78-86.43-86.43-86.43z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 298.43c-40.49 0-73.43-32.94-73.43-73.43s32.94-73.43 73.43-73.43 73.43 32.94 73.43 73.43-32.94 73.43-73.43 73.43zm0-136.86c-34.97 0-63.43 28.45-63.43 63.43s28.45 63.43 63.43 63.43c34.97 0 63.43-28.45 63.43-63.43s-28.46-63.43-63.43-63.43z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 264.3c-2.76 0-5-2.24-5-5v-57.71l-11.07 9.51c-2.09 1.8-5.25 1.56-7.05-.53-1.8-2.1-1.56-5.25.53-7.05l19.33-16.6c1.48-1.27 3.57-1.57 5.35-.75 1.77.82 2.91 2.59 2.91 4.54v68.59c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.42 264.3h-26.84c-2.76 0-5-2.24-5-5s2.24-5 5-5h26.84c2.76 0 5 2.24 5 5s-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.5 230h-41.39c-2.76 0-5-2.24-5-5s2.24-5 5-5h41.39c2.76 0 5 2.24 5 5s-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.89 230h-41.39c-2.76 0-5-2.24-5-5s2.24-5 5-5h41.39c2.76 0 5 2.24 5 5s-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 170.43c-2.76 0-5-2.24-5-5v-41.25c0-2.76 2.24-5 5-5s5 2.24 5 5v41.25c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 330.82c-2.76 0-5-2.24-5-5v-41.25c0-2.76 2.24-5 5-5s5 2.24 5 5v41.25c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.72 99.32c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.48 99.32c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.24 99.32c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 99.32c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.76 99.32c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.52 99.32c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.28 99.32c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.04 99.32h-430.08c-2.76 0-5-2.24-5-5s2.24-5 5-5h430.08c2.76 0 5 2.24 5 5s-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.72 413.42c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.48 413.42c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.24 413.42c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 413.42c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.76 413.42c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.52 413.42c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.28 413.42c-2.76 0-5-2.24-5-5v-52.74c0-2.76 2.24-5 5-5s5 2.24 5 5v52.74c0 2.76-2.24 5-5 5z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.04 360.68h-430.08c-2.76 0-5-2.24-5-5s2.24-5 5-5h430.08c2.76 0 5 2.24 5 5s-2.24 5-5 5z",
    fill: "#c72538"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShort);
export default __webpack_public_path__ + "static/media/short.5086497f9a705461889771c84534feeb.svg";
export { ForwardRef as ReactComponent };